<template>
  <div
    v-if="allowedProviders.length"
    class="text-center"
  >
    <div class="d-flex">
      <FacebookIcon
        v-if="allowedProviders.includes('facebook')"
        @click="handleFacebookClick"
      />
      <GoogleIcon
        v-if="allowedProviders.includes('google')"
        @click="handleGoogleClick"
      />
      <WechatIcon
        v-if="allowedProviders.includes('qq')"
        @click="handleWechatClick"
      />
    </div>
    <div class="py-4">
      {{ $t('or-use') }}
    </div>
  </div>
</template>

<script>
import FacebookIcon from '@/components/Atoms/Icons/FacebookIcon'
import WechatIcon from '@/components/Atoms/Icons/WechatIcon'
import GoogleIcon from '@/components/Atoms/Icons/GoogleIcon'

export default {
  name: 'SocialiteButtons',
  components: {
    GoogleIcon,
    WechatIcon,
    FacebookIcon,
  },
  data() {
    return {
      popup: null,
    }
  },
  computed: {
    allowedProviders() {
      const providers = process.env.VUE_APP_SOCIALITE_PROVIDERS
      return providers ? providers.split(',') : []
    },
    authUrl() {
      return process.env.VUE_APP_IS_MULTI_DOMAIN
        ? `${window.location.origin}/`
        : process.env.VUE_APP_AUTH_URL
    },
  },
  methods: {
    callback() {
      location.reload()
    },
    handleFacebookClick() {
      this.popup = window.open(
        `${this.authUrl}auth/facebook`,
        'login',
        `height=${600},width=${700}`
      )
      this.popup.window.focus()
      this.popup.onbeforeunload = this.callback
    },
    handleGoogleClick() {
      this.popup = window.open(
        `${this.authUrl}auth/google`,
        'login',
        `height=${600},width=${700}`
      )
      this.popup.window.focus()
      this.popup.onbeforeunload = this.callback
    },
    handleWechatClick() {
      this.$emit('click')
      window.location.href = `${this.authUrl}auth/wechat`
    },
  },
}
</script>
